import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { PanelComponent } from "./panelComponent";

export * from "./panelComponent";

@NgModule({
  imports: [
    CommonModule,
    FormsModule    
  ],
  declarations: [
    PanelComponent 
  ],
  exports: [
    PanelComponent
  ]
})
export class PanelModule {

}